var render = function render(){var _vm=this,_c=_vm._self._c;return _c('steps-option',{attrs:{"disable-accordions":true},on:{"updateNavigation":_vm.updateNavigation}})
}
var staticRenderFns = []

export { render, staticRenderFns }